import React, { useEffect, useState } from 'react';

//Material
import styled from '@emotion/styled';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Box,
  Checkbox,
  ClickAwayListener,
  FormControlLabel,
  Grid,
  Modal,
  TextField,
  Typography
} from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import './ServiceModal.css';
// import { useTranslate } from 'react-redux-multilingual';
// import { useSnackbar } from 'notistack';
import { StyledLabel } from '../../components/StyledComponents';
// import ApiService from '../../helpers/apiHelper';
import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn3 } from '../../components/Buttons';
import {
  setIsOpenImageCropModal,
  setIsOpenServiceModal,
  setUserData
} from '../../redux/mainReducer';
// import { useSnackbar } from 'notistack';
// import {  encode as btoa, decode as atob } from 'base-64';
// import sha256 from 'crypto-js/sha256';
// import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import EmojiPicker from 'emoji-picker-react';
import { useSnackbar } from 'notistack';
import { useTranslate } from 'react-redux-multilingual';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../../components/Spinner';
import ApiService from '../../helpers/apiHelper';
import { ImageOutlined } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: { xs: 390, sm: 710, md: 820, lg: 1100, xl: 1100 },
  bgcolor: 'background.paper',
  borderRadius: '8px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflowY: 'scroll',
  overflowX: 'hidden',
  height: 'inherit',
  maxHeight: { xs: '100vh', sm: '85vh' }
  // scrollbarWidth: 'none',
  // '&::-webkit-scrollbar': {
  //   display: 'none'
  // }
};
const styleError = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: { xs: 390, sm: 710, md: 820, lg: 1100, xl: 1100 },
  bgcolor: 'background.paper',
  borderRadius: '8px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflowY: 'scroll',
  overflowX: 'hidden',
  height: 'auto',
  maxHeight: { xs: '100vh', sm: '85vh' }
  // scrollbarWidth: 'none',
  // '&::-webkit-scrollbar': {
  //   display: 'none'
  // }
};

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function ServiceModal({ isOpenModal, language, setter, data, userData }) {
  const [imgs, setImgs] = useState([]);
  const [newImgs, setNewImgs] = useState([]);
  const [imgsToDelete, setImgsToDelete] = useState([]);

  const [screenType, setScreenType] = useState('desktop');
  const [stage, setStage] = useState('1');
  const [isShowEmoji, setIsShowEmoji] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // const isOpenDeleteModal = useSelector((state) => state.global.isOpenDeleteModal);

  // const { btoa } = window;
  //const userData = useSelector((state=>state.global.userData)) //for test
  //console.log(userData) // for test
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (window.screen.width <= 600) {
      setScreenType('mobile');
    }
  }, []);
  const translate = useTranslate();
  const { enqueueSnackbar } = useSnackbar();

  const api = new ApiService(`posts/service${data ? '/' : ''}${data ? data.id : ''}`, translate);
  const photoApi = new ApiService('photo/bucket/upload-file');
  // const api = new ApiService(`service${data ? '/' : ''}${data ? data.id : ''}`, translate);
  // const photoApi = new ApiService('/bucket/upload-file');

  // const apiPhoto = new ApiService('photo/get-photo');
  // const apiPhoto = new ApiService('get-photo');
  const decounter = () => {
    dispatch(setUserData({ ...userData, countServices: userData?.countServices - 1 }));
  };

  const schema = Yup.object().when((values, schema) => {
    if (values?.availability === 'Є в наявності') {
      return schema.shape({
        nameService: Yup.string()
          .min(2, 'Мінімально 2 символи')
          .max(32, 'Максимально 32 символи')
          .required("Це поле обов'язкове"),
        price: Yup.number()
          .min(0, 'Ціна не може бути меншою за 0')
          .max(99999999, 'Максимально 99999999')
          .typeError('Тільки число')
          .required("Це поле обов'язкове"),
        valueOfInitOfMeasure: Yup.number()
          .typeError('Тільки число')
          .min(0, 'Кількість не може бути меншою за 0')
          .max(99999999, 'Максимально 99999999')
          .required("Це поле обов'язкове"),
        description: Yup.string()
          .min(10, 'Мінімально 10 символів')
          .max(1000, 'Максимально 1000 символів'),
        availability: Yup.string().required("Це поле обов'язкове"),
        initOfMeasure: Yup.string().required("Це поле обов'язкове"),
        category: Yup.string().required("Це поле обов'язкове"),
        currency: Yup.string().required("Це поле обов'язкове"),
        deliveryOption: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        paymentOption: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        deliveryDays: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        estimatedTime: Yup.number()
          .min(1, 'Не може бути меншим за 1')
          .max(366, 'Не може бути більшим за 366')
          .typeError('Тільки число')
          .required("Це поле обов'язкове"),
        availableQuantity: Yup.number()
          .typeError('Тільки число')
          .min(1, 'Мінімально 1')
          .max(99999999, 'Максимально 99999999')
          .required("Це поле обов'язкове")
      });
    } else if (values?.availability === 'Під замовлення') {
      return schema.shape({
        nameService: Yup.string()
          .min(2, 'Мінімально 2 символи')
          .max(32, 'Максимально 32 символи')
          .required("Це поле обов'язкове"),
        price: Yup.number()
          .min(0, 'Ціна не може бути меншою за 0')
          .max(99999999, 'Максимально 99999999')
          .typeError('Тільки число')
          .required("Це поле обов'язкове"),
        valueOfInitOfMeasure: Yup.number()
          .typeError('Тільки число')
          .min(0, 'Кількість не може бути меншою за 0')
          .max(99999999, 'Максимально 99999999')
          .required("Це поле обов'язкове"),
        description: Yup.string()
          .min(10, 'Мінімально 10 символів')
          .max(1000, 'Максимально 1000 символів'),
        availability: Yup.string().required("Це поле обов'язкове"),
        initOfMeasure: Yup.string().required("Це поле обов'язкове"),
        category: Yup.string().required("Це поле обов'язкове"),
        currency: Yup.string().required("Це поле обов'язкове"),
        deliveryOption: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        paymentOption: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        deliveryDays: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        estimatedTime: Yup.number()
          .min(1, 'Не може бути меншим за 1')
          .max(366, 'Не може бути більшим за 366')
          .typeError('Тільки число')
          .required("Це поле обов'язкове"),
        availableQuantity: Yup.number()
          .typeError('Тільки число')
          .max(0, 'Максимально 0')
          .min(0, 'Мінімально 0')
          .required("Це поле обов'язкове")
      });
    } else {
      return schema.shape({
        nameService: Yup.string()
          .min(2, 'Мінімально 2 символи')
          .max(32, 'Максимально 32 символи')
          .required("Це поле обов'язкове"),
        price: Yup.number()
          .min(0, 'Ціна не може бути меншою за 0')
          .max(99999999, 'Максимально 99999999')
          .typeError('Тільки число')
          .required("Це поле обов'язкове"),
        valueOfInitOfMeasure: Yup.number()
          .typeError('Тільки число')
          .min(0, 'Кількість не може бути меншою за 0')
          .max(99999999, 'Максимально 99999999')
          .required("Це поле обов'язкове"),
        description: Yup.string()
          .min(10, 'Мінімально 10 символів')
          .max(1000, 'Максимально 1000 символів'),
        availability: Yup.string().required("Це поле обов'язкове"),
        initOfMeasure: Yup.string().required("Це поле обов'язкове"),
        category: Yup.string().required("Це поле обов'язкове"),
        currency: Yup.string().required("Це поле обов'язкове"),
        deliveryOption: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        paymentOption: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        deliveryDays: Yup.array()
          .min(1, 'Потрібно обрати хочаб один варінт')
          .required("Це поле обов'язкове"),
        estimatedTime: Yup.number()
          .min(1, 'Не може бути меншим за 1')
          .max(366, 'Не може бути більшим за 366')
          .typeError('Тільки число')
          .required("Це поле обов'язкове"),
        availableQuantity: Yup.number()
          .typeError('Тільки число')
          .max(0, 'Максимально 0')
          .min(0, 'Мінімально 0')
          .required("Це поле обов'язкове")
      });
    }
  });

  const formik = useFormik({
    initialValues: {
      nameService: data?.nameService ? data.nameService : '',
      category: data?.category ? data.category : '',
      description: data?.description ? data.description : '',
      price: data?.price ? data.price : '',
      currency: data?.currency ? data.currency : 'грн',
      valueOfInitOfMeasure: data?.valueOfInitOfMeasure ? data.valueOfInitOfMeasure : '',
      initOfMeasure: data?.initOfMeasure ? data.initOfMeasure : 'шт',
      availability: data?.availability ? data.availability : '',
      deliveryOption: data?.deliveryOption ? data.deliveryOption : [],
      paymentOption: data?.paymentOption ? data.paymentOption : [],
      deliveryDays: data?.deliveryDays ? data.deliveryDays : [],
      estimatedTime: data?.estimatedTime ? data.estimatedTime : '',
      availableQuantity: data?.availableQuantity ? data?.availableQuantity : 0
    },
    enableReinitialize: true,
    validationSchema: schema,

    onSubmit: async (values, { resetForm, setErrors }) => {
      setIsLoading(true);
      if (data) {
        const imgsNew = await Promise.all(
          newImgs.map((img) => photoApi.sendRequest({ file: img }, true).then((res) => res.result))
        );

        api
          .updateData(
            {
              ...values,
              newPhotos: imgsNew,
              listDeletedPhotos: imgsToDelete,
              deliveryDays: values.deliveryDays.filter((option) => option !== 'Щодня')
            },
            true
          )
          .then((res) => {
            setter(true);
            dispatch(setIsOpenServiceModal({ isOpen: false, data: null, setter: null }));
            setIsShowEmoji(false);
            enqueueSnackbar('Зміни збережено', { variant: 'success' });
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
            enqueueSnackbar(error, { variant: 'error' });
          });
      } else {
        const photoIds = await Promise.all(
          imgs.map((img) => photoApi.sendRequest({ file: img }, true).then((res) => res.result))
        );
        api
          .sendRequest(
            {
              ...values,
              photoIds: photoIds,
              deliveryDays: values.deliveryDays.filter((option) => option !== 'Щодня')
            },
            true
          )
          .then((res) => {
            setter(true);
            dispatch(setIsOpenServiceModal({ isOpen: false, data: null, setter: null }));
            dispatch(setUserData({ ...userData, countServices: userData?.countServices + 1 }));
            enqueueSnackbar('Товар успішно створено', { variant: 'success' });
            setIsShowEmoji(false);
            setIsLoading(false);
          })
          .catch((error) => {
            if (error === 'Ви вичерпали ліміт доступних товарів!') {
              setStage('2');
            }
            if (error === 'Ви вичерпали ліміт доступних товарів у пробному тарифі!') {
              setStage('3');
            }

            setIsLoading(false);
            enqueueSnackbar(error, { variant: 'error' });
          });
      }
    }
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    submitForm,
    resetForm,
    setFieldValue
  } = formik;
  // function getFileFromBase64(string64, fileName) {
  //   const trimmedString = string64.replace('dataimage/jpegbase64', '');
  //   const imageContent = atob(trimmedString);
  //   const buffer = new ArrayBuffer(imageContent.length);
  //   const view = new Uint8Array(buffer);

  //   for (let n = 0; n < imageContent.length; n++) {
  //     view[n] = imageContent.charCodeAt(n);
  //   }
  //   const type = 'image/jpeg';
  //   const blob = new Blob([buffer], { type });
  //   return new File([blob], fileName, { lastModified: new Date().getTime(), type });
  // }
  useEffect(() => {
    if (data) {
      const getPhotos = async () => {
        setImgs([...data?.photoUrls]);
      };
      getPhotos();

      // setImgs([
      //   ...getPhotos().map((photo) => getFileFromBase64(photo.encodedContent, data.nameFile))
      // ]);
      if (
        data &&
        data?.deliveryDays &&
        data.deliveryDays.includes('Понеділок') &&
        data.deliveryDays.includes('Вівторок') &&
        data.deliveryDays.includes('Середа') &&
        data.deliveryDays.includes('Четвер') &&
        data.deliveryDays.includes("П'ятниця") &&
        data.deliveryDays.includes('Субота') &&
        data.deliveryDays.includes('Неділя')
      ) {
        setFieldValue('deliveryDays', [
          'Щодня',
          'Понеділок',
          'Вівторок',
          'Середа',
          'Четвер',
          "П'ятниця",
          'Субота',
          'Неділя'
        ]);
      }
    }
    return () => {
      clearTimeout(decounter);
      setImgs([]);
      setNewImgs([]);
      setImgsToDelete([]);
    };
    // eslint-disable-next-line
  }, [data]);
  const handleChange = (type, text) => {
    if (type === 'delivery') {
      if (values.deliveryOption.includes(text)) {
        setFieldValue('deliveryOption', [
          ...values.deliveryOption.filter((option) => option !== text)
        ]);
      } else {
        setFieldValue('deliveryOption', [...values.deliveryOption, text]);
      }
    } else {
      if (values.paymentOption.includes(text)) {
        setFieldValue('paymentOption', [
          ...values.paymentOption.filter((option) => option !== text)
        ]);
      } else {
        setFieldValue('paymentOption', [...values.paymentOption, text]);
      }
    }
  };
  return (
    <div>
      {/* <DeleteModal isOpenModal={isOpenDeleteModal} func={deleteService} text="цю послугу?" /> */}
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          dispatch(setIsOpenServiceModal({ isOpen: false, data: null, setter: null }));

          resetForm();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_service_modal"
      >
        <Box sx={stage === '1' ? style : styleError} className="bonfair_service_modal-box">
          <CloseIcon
            className="bonfair_service_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenServiceModal({ isOpen: false, data: null, setter: null }));

              resetForm();
            }}
          />

          {stage === '1' ? (
            <FormikProvider value={formik}>
              <Form
                autoComplete="off"
                noValidate
                onSubmit={handleSubmit}
                style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}
              >
                <Grid container spacing={screenType !== 'desktop' ? 1 : 4}>
                  <Grid item xs={12} md={12} lg={12}>
                    <StyledLabel className="serviceModal-title-text">
                      {/* {translate('bonfair_service_modal')} */}
                      {data ? 'Редагування товару' : 'Створення товару'}
                    </StyledLabel>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative',
                      height: '115px'
                    }}
                  >
                    <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                      Назва товару
                    </Typography>
                    <CssTextField
                      label=""
                      placeholder="Введіть назву товару*"
                      variant="outlined"
                      fullWidth
                      size="normal"
                      inputProps={{ style: { textAlign: 'left' } }}
                      error={Boolean(touched.nameService && errors.nameService)}
                      {...getFieldProps('nameService')}
                      value={values.nameService}
                      onChange={(event) => {
                        if (event.target.value.length <= 32) {
                          setFieldValue('nameService', event.target.value);
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <p
                            style={{
                              margin: '0 10px',
                              color: values.nameService.length <= 32 ? 'gray' : 'red',
                              textAlign: 'left',
                              fontSize: '14px'
                              // paddingLeft: '10px'
                            }}
                          >{`${values.nameService.length}/32`}</p>
                        )
                      }}
                    >
                      {values.nameService}
                    </CssTextField>

                    {touched.nameService && errors.nameService && (
                      <div
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          fontFamily: 'FixelText-Regular'
                        }}
                      >
                        {errors.nameService}
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ height: '115px' }}>
                    <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                      Категорія
                    </Typography>
                    <Autocomplete
                      disableClearable
                      onKeyPress={(e) => {
                        e.preventDefault();
                      }}
                      options={[
                        'Їжа та напої',
                        'Одяг та взуття',
                        'Канцелярія',
                        'Косметика',
                        'Аксесуари',
                        'Товари для дому',
                        'Флористика',
                        'Товари для дітей',
                        'Інше'
                      ]}
                      value={values.category}
                      onChange={(event, value) => setFieldValue('category', value)}
                      renderInput={(params) => (
                        <CssTextField {...params} placeholder="Обери категорію*" />
                      )}
                    />
                    {touched.category && errors.category && (
                      <div
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          fontFamily: 'FixelText-Regular'
                        }}
                      >
                        {errors.category}
                      </div>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    sx={{ position: 'relative', height: '115px' }}
                  >
                    <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                      Ціна
                    </Typography>
                    <CssTextField
                      sx={{
                        '& .MuiInputBase-root': {
                          paddingRight: '0 !important'
                        }
                      }}
                      label=""
                      placeholder="Ціна*"
                      variant="outlined"
                      fullWidth
                      size="normal"
                      inputProps={{ style: { textAlign: 'left' } }}
                      error={Boolean(touched.price && errors.price)}
                      {...getFieldProps('price')}
                      value={values.price}
                      InputProps={{
                        endAdornment: (
                          <Autocomplete
                            disabled
                            sx={{ p: '3.5px 0px !important' }}
                            disableClearable
                            onKeyPress={(e) => {
                              e.preventDefault();
                            }}
                            defaultValue="грн"
                            options={['грн', 'USD', 'EUR']}
                            value={values.currency}
                            onChange={(event, value) => setFieldValue('currency', value)}
                            renderInput={(params) => (
                              <CssTextField
                                {...params}
                                placeholder="Валюта*"
                                sx={{
                                  '& .MuiInputBase-root': {
                                    boxShadow: 'none !important',
                                    padding: '0 !important',
                                    width: '70px',
                                    backgroundColor: 'transparent !important'
                                  }
                                }}
                              />
                            )}
                          />
                          // <p
                          //   style={{
                          //     margin: '0 10px',
                          //     color: values.nameService.length <= 32 ? 'gray' : 'red',
                          //     textAlign: 'left',
                          //     fontSize: '14px'
                          //     // paddingLeft: '10px'
                          //   }}
                          // >{`${values.nameService.length}/32`}</p>
                        )
                      }}
                    >
                      {values.price}
                    </CssTextField>
                    {touched.price && errors.price && (
                      <div
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          fontFamily: 'FixelText-Regular',
                          width: 'max-content'
                        }}
                      >
                        {errors.price}
                      </div>
                    )}
                  </Grid>
                  {/*<Grid item xs={12} sm={6} md={6} lg={6} sx={{ position: 'relative' }}>*/}
                  {/*  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>*/}
                  {/*    Валюта*/}
                  {/*  </Typography>*/}
                  {/*  <Autocomplete*/}
                  {/*    disableClearable*/}
                  {/*    disabled*/}
                  {/*    onKeyPress={(e) => {*/}
                  {/*      e.preventDefault();*/}
                  {/*    }}*/}
                  {/*    defaultValue="грн"*/}
                  {/*    options={['грн', 'USD', 'EUR']}*/}
                  {/*    value={values.currency}*/}
                  {/*    onChange={(event, value) => setFieldValue('currency', value)}*/}
                  {/*    renderInput={(params) => <CssTextField {...params} placeholder="Валюта*" />}*/}
                  {/*  />*/}

                  {/*  {touched.currency && errors.currency && (*/}
                  {/*    <div*/}
                  {/*      style={{*/}
                  {/*        position: 'absolute',*/}
                  {/*        bottom: '-18px',*/}
                  {/*        color: 'red',*/}
                  {/*        margin: '5px 0px',*/}
                  {/*        fontSize: '14px',*/}
                  {/*        fontFamily: 'FixelText-Regular'*/}
                  {/*      }}*/}
                  {/*    >*/}
                  {/*      {errors.currency}*/}
                  {/*    </div>*/}
                  {/*  )}*/}
                  {/*</Grid>*/}

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    className="serviceModal-inputs-first"
                    sx={{ position: 'relative', height: '115px' }}
                  >
                    <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                      Міра товару
                    </Typography>
                    <CssTextField
                      label=""
                      placeholder="Обʼєм, вага, кількість*"
                      variant="outlined"
                      fullWidth
                      size="normal"
                      sx={{
                        '& .MuiInputBase-root': {
                          paddingRight: '0 !important'
                        }
                      }}
                      inputProps={{ style: { textAlign: 'left' } }}
                      error={Boolean(touched.valueOfInitOfMeasure && errors.valueOfInitOfMeasure)}
                      {...getFieldProps('valueOfInitOfMeasure')}
                      value={values.valueOfInitOfMeasure}
                      InputProps={{
                        endAdornment: (
                          <Autocomplete
                            sx={{ p: '3.5px 0px !important' }}
                            disableClearable
                            onKeyPress={(e) => {
                              e.preventDefault();
                            }}
                            defaultValue="шт"
                            options={['г', 'кг', 'мл', 'л', 'см', 'м', 'шт', '-']}
                            value={values.initOfMeasure}
                            onChange={(event, value) => setFieldValue('initOfMeasure', value)}
                            renderInput={(params) => (
                              <CssTextField
                                {...params}
                                placeholder="Одиниці*"
                                sx={{
                                  '& .MuiInputBase-root': {
                                    boxShadow: 'none !important',
                                    padding: '0 !important',
                                    width: '70px',
                                    backgroundColor: 'transparent !important'
                                  }
                                }}
                              />
                            )}
                          />
                          // <p
                          //   style={{
                          //     margin: '0 10px',
                          //     color: values.nameService.length <= 32 ? 'gray' : 'red',
                          //     textAlign: 'left',
                          //     fontSize: '14px'
                          //     // paddingLeft: '10px'
                          //   }}
                          // >{`${values.nameService.length}/32`}</p>
                        )
                      }}
                    >
                      {values.valueOfInitOfMeasure}
                    </CssTextField>
                    {touched.valueOfInitOfMeasure && errors.valueOfInitOfMeasure && (
                      <div
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          fontFamily: 'FixelText-Regular',
                          width: 'max-content'
                        }}
                      >
                        {errors.valueOfInitOfMeasure}
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={{ fontFamily: 'FixelText-Regular', fontSize: '18px' }}>
                      Примітка: ціна вказана за задану міру товару. Наприклад, 120 грн за 0.7 л вина
                      — при замовленні 2 одиниць покупець отримає 1.4 л за 240 грн.
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ height: '115px' }}>
                    <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                      Наявність
                    </Typography>
                    <Autocomplete
                      disableClearable
                      onKeyPress={(e) => {
                        e.preventDefault();
                      }}
                      options={['Є в наявності', 'Під замовлення', 'Немає в наявності']}
                      value={values.availability}
                      onChange={(event, value) => {
                        setFieldValue('availability', value);
                      }}
                      renderInput={(params) => (
                        <CssTextField {...params} placeholder="Наявність*" />
                      )}
                    />
                    {touched.availability && errors.availability && (
                      <div
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          fontFamily: 'FixelText-Regular'
                        }}
                      >
                        {errors.availability}
                      </div>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative',
                      height: '115px'
                    }}
                  >
                    <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                      Кількість у наявності
                    </Typography>
                    <CssTextField
                      label=""
                      placeholder="К-ть в наявності"
                      variant="outlined"
                      fullWidth
                      size="normal"
                      inputProps={{ style: { textAlign: 'left' } }}
                      error={Boolean(errors.availableQuantity)}
                      {...getFieldProps('availableQuantity')}
                      value={values.availableQuantity}
                    >
                      {values.availableQuantity}
                    </CssTextField>
                    {errors.availableQuantity && (
                      <div
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          fontFamily: 'FixelText-Regular'
                        }}
                      >
                        {errors.availableQuantity}
                      </div>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    className="serviceModal-inputs-first"
                    sx={{ position: 'relative' }}
                  >
                    <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                      Опис
                    </Typography>
                    <CssTextField
                      placeholder="Опишіть головні особливості Вашого унікального товару"
                      multiline
                      rows={8}
                      fullWidth
                      inputProps={{ style: { textAlign: 'left' } }}
                      InputProps={{
                        endAdornment: (
                          <>
                            <EmojiEmotionsOutlinedIcon
                              onClick={() => {
                                setIsShowEmoji(!isShowEmoji);
                              }}
                              sx={{
                                display: { xs: 'none', md: 'inline-block' },
                                color: '#60A5DF',
                                cursor: 'pointer',
                                fontSize: '20px',
                                mr: 1
                              }}
                            />
                          </>
                        )
                      }}
                      error={Boolean(touched.description && errors.description)}
                      {...getFieldProps('description')}
                      value={values.description}
                    >
                      {values.description}
                    </CssTextField>
                    {values.description.length !== 0 && (
                      <p
                        style={{
                          margin: '0 5px',
                          color: 'gray',
                          textAlign: 'right',
                          fontSize: '14px'
                        }}
                      >{`${values.description.length}/1000`}</p>
                    )}
                    {touched.description && errors.description && (
                      <div
                        style={{
                          color: 'red',
                          margin: '5px 0px',
                          fontSize: '14px',
                          fontFamily: 'FixelText-Regular'
                        }}
                      >
                        {errors.description}
                      </div>
                    )}
                    {isShowEmoji && (
                      <ClickAwayListener
                        onClickAway={() => {
                          setIsShowEmoji(false);
                        }}
                      >
                        <Box>
                          {' '}
                          <EmojiPicker
                            onEmojiClick={(emojiData, event) => {
                              let newStr = `${values.description}${emojiData.emoji}`;
                              setFieldValue('description', newStr);
                            }}
                            skinTonesDisabled
                            searchDisabled
                            previewConfig={{ showPreview: false }}
                            style={{
                              position: 'absolute',
                              bottom: '-280px',
                              right: '50px',
                              zIndex: '99'
                            }}
                            width={'60%'}
                            height={'300px'}
                          />
                        </Box>
                      </ClickAwayListener>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      flexDirection: 'column'
                    }}
                  >
                    {' '}
                    <Grid
                      container
                      spacing={1}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                        // pl: '8px'
                      }}
                    >
                      {!data && (
                        <>
                          <Typography variant="subtitle2" sx={{ mb: 1, fontSize: 16 }}>
                            Фотографії
                          </Typography>
                          <Typography
                            variant="subtitle"
                            sx={{ fontSize: 16, color: '#B1B1B1', mb: 2 }}
                          >
                            Можливо завантажити до 10 вкладень. Один елемент не має важити більше 10
                            МБ.
                          </Typography>
                        </>
                      )}

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{ display: 'flex', alignItems: 'left', pl: '0px !important' }}
                      >
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'flex-start',
                            gap: '12px',
                            alignSelf: 'stretch',
                            zIndex: '99',
                            // paddingTop: '14px',
                            padding: '12px',
                            marginBottom: '20px',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                            background: 'white',
                            borderRadius: '5px'
                          }}
                        >
                          {imgs.length !== 0 &&
                            imgs.map((file, index) => (
                              <div key={'image' + index} className="uploaded-img-modal">
                                {index === 0 ? (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      backgroundColor: '#E2F2FF',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                                      fontFamily: 'FixelText-Medium',
                                      fontWeight: '500',
                                      color: '#60A5DF',
                                      fontSize: '14px',
                                      top: '4px',
                                      left: '4px'
                                    }}
                                  >
                                    Обкладинка
                                  </div>
                                ) : null}
                                <img
                                  style={{
                                    objectFit: 'cover',
                                    width: '100%',
                                    height: '100%'
                                  }}
                                  alt={'img' + index}
                                  src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                                />
                                <div
                                  style={{
                                    position: 'absolute',
                                    backgroundColor: 'white',
                                    width: '26px',
                                    height: '26px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50px',
                                    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                                    cursor: 'pointer',
                                    top: '4px',
                                    right: '4px'
                                  }}
                                  onClick={() => {
                                    const newArray = imgs;
                                    const newImgsToDelete = imgsToDelete;

                                    if (data) {
                                      const match = data?.photoUrls
                                        .find((file, i) => index === i)
                                        // eslint-disable-next-line
                                        .match(/com\/([^?]+)/);
                                      const imgPath = match
                                        ? `img/${match[1].split('img/')[1]}`
                                        : null;
                                      newImgsToDelete.push(imgPath);
                                    }

                                    newArray.splice(index, 1);
                                    setImgs([...newArray]);
                                    setImgsToDelete([...newImgsToDelete]);
                                  }}
                                >
                                  <CloseIcon sx={{ fontSize: '20px' }} />
                                </div>
                              </div>
                            ))}
                          <input
                            multiple
                            // accept="image/*"
                            accept=".jpeg,.jpg,.png"
                            style={{ display: 'none' }}
                            id="button-file-service"
                            disabled={imgs.length === 10 ? true : false}
                            onChange={(event) => {
                              if (imgs.length !== 10) {
                                dispatch(
                                  setIsOpenImageCropModal({
                                    isOpen: true,
                                    file: event?.target?.files[0],
                                    setter: (file) => {
                                      if (data) {
                                        const newImgsArray = [...newImgs];
                                        newImgsArray.push(file);
                                        setNewImgs([...newImgsArray]);
                                      }
                                      const newArray = [...imgs];
                                      newArray.push(file);
                                      setImgs([...newArray]);
                                    }
                                  })
                                );
                              }
                              event.target.value = '';
                            }}
                            type="file"
                          />
                          {imgs.length !== 10 && (
                            <label htmlFor="button-file-service">
                              <div className="uploaded-img-modal-label">
                                <ImageOutlined
                                  style={{ color: 'black' }}
                                  sx={{
                                    mt: 1,
                                    fontSize: 35,
                                    '&:hover': {
                                      width: 100
                                    }
                                  }}
                                />
                                <Typography
                                  sx={{
                                    mt: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontFamily: 'FixelText-Medium'
                                  }}
                                >
                                  <AddIcon sx={{ color: 'black', mr: '2px' }} /> Додати
                                </Typography>
                              </div>
                            </label>
                          )}
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ mb: 2, fontSize: 16, fontFamily: 'FixelText-SemiBold' }}
                        >
                          Варіанти доставки:
                        </Typography>
                        <Typography
                          variant="subtitle"
                          sx={{ fontSize: 16, color: '#B1B1B1', mb: 2 }}
                        >
                          Оберіть які варіанти доставки можливі для Вашого товару*.
                        </Typography>
                        <FormControlLabel
                          sx={{ ml: '0px', mb: 0.5, width: 'fit-content' }}
                          control={
                            <Checkbox
                              disableRipple
                              checked={values.deliveryOption.includes('Нова Пошта')}
                              onChange={() => {
                                handleChange('delivery', 'Нова Пошта');
                              }}
                              sx={{
                                width: '25px',
                                height: '25px',
                                '&.Mui-checked': {
                                  color: 'rgba(96, 165, 223, 1) !important'
                                }
                              }}
                            />
                          }
                          label="Нова Пошта"
                        />
                        <FormControlLabel
                          sx={{ ml: '0px', mb: 0.5, width: 'fit-content' }}
                          control={
                            <Checkbox
                              disableRipple
                              checked={values.deliveryOption.includes('УкрПошта')}
                              onChange={() => handleChange('delivery', 'УкрПошта')}
                              sx={{
                                width: '25px',
                                height: '25px',
                                '&.Mui-checked': {
                                  color: 'rgba(96, 165, 223, 1) !important'
                                }
                              }}
                            />
                          }
                          label="УкрПошта"
                        />
                        <FormControlLabel
                          sx={{ ml: '0px', width: 'fit-content' }}
                          control={
                            <Checkbox
                              disableRipple
                              checked={values.deliveryOption.includes("Кур'єр")}
                              onChange={() => handleChange('delivery', "Кур'єр")}
                              sx={{
                                width: '25px',
                                height: '25px',
                                '&.Mui-checked': {
                                  color: 'rgba(96, 165, 223, 1) !important'
                                }
                              }}
                            />
                          }
                          label="Кур'єр"
                        />
                        <div
                          style={{
                            color: 'red',
                            margin: '5px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {touched.deliveryOption && errors.deliveryOption}
                        </div>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ mb: 2, fontSize: 16, fontFamily: 'FixelText-SemiBold' }}
                        >
                          Варіанти оплати:
                        </Typography>
                        <Typography
                          variant="subtitle"
                          sx={{ fontSize: 16, color: '#B1B1B1', mb: 2 }}
                        >
                          Оберіть які варіанти оплати можливі для вашого товару*.
                        </Typography>
                        <FormControlLabel
                          sx={{ ml: '0px', mb: 0.5, width: 'fit-content' }}
                          control={
                            <Checkbox
                              disableRipple
                              checked={values.paymentOption.includes('Повна оплата')}
                              onChange={() => handleChange('payment', 'Повна оплата')}
                              sx={{
                                width: '25px',
                                height: '25px',
                                '&.Mui-checked': {
                                  color: 'rgba(96, 165, 223, 1) !important'
                                }
                              }}
                            />
                          }
                          label="Повна оплата"
                        />
                        <FormControlLabel
                          sx={{ ml: '0px', mb: 0.5, width: 'fit-content' }}
                          control={
                            <Checkbox
                              disableRipple
                              checked={values.paymentOption.includes('Часткова передоплата')}
                              onChange={() => handleChange('payment', 'Часткова передоплата')}
                              sx={{
                                width: '25px',
                                height: '25px',
                                '&.Mui-checked': {
                                  color: 'rgba(96, 165, 223, 1) !important'
                                }
                              }}
                            />
                          }
                          label="Часткова передоплата"
                        />
                        <FormControlLabel
                          sx={{ ml: '0px', width: 'fit-content' }}
                          control={
                            <Checkbox
                              disableRipple
                              checked={values.paymentOption.includes('Оплата при отриманні')}
                              onChange={() => handleChange('payment', 'Оплата при отриманні')}
                              sx={{
                                width: '25px',
                                height: '25px',
                                '&.Mui-checked': {
                                  color: 'rgba(96, 165, 223, 1) !important'
                                }
                              }}
                            />
                          }
                          label="Оплата при отриманні"
                        />
                        <div
                          style={{
                            color: 'red',
                            margin: '5px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {touched.paymentOption && errors.paymentOption}
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        sx={{
                          display: 'flex',
                          alignItems: 'left',
                          flexDirection: 'column'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ mb: 2, fontSize: 16, fontFamily: 'FixelText-SemiBold' }}
                        >
                          Дні відправки замовлення:
                        </Typography>
                        <Typography
                          variant="subtitle"
                          sx={{ fontSize: 16, color: '#B1B1B1', mb: 2 }}
                        >
                          Оберіть дні, в які можлива відправка для вашого товару*.
                        </Typography>
                        <Autocomplete
                          value={values.deliveryDays}
                          onChange={(event, newValue) => {
                            if (newValue.includes('Щодня') && newValue.length === 1) {
                              setFieldValue('deliveryDays', [
                                'Щодня',
                                'Понеділок',
                                'Вівторок',
                                'Середа',
                                'Четвер',
                                "П'ятниця",
                                'Субота',
                                'Неділя'
                              ]);
                            } else if (
                              newValue.includes('Щодня') &&
                              values.deliveryDays.includes('Щодня') &&
                              newValue.length < 8
                            ) {
                              setFieldValue(
                                'deliveryDays',
                                newValue.filter((el) => el !== 'Щодня')
                              );
                            } else if (
                              newValue.includes('Щодня') &&
                              !values.deliveryDays.includes('Щодня') &&
                              newValue.length < 8
                            ) {
                              setFieldValue('deliveryDays', [
                                'Щодня',
                                'Понеділок',
                                'Вівторок',
                                'Середа',
                                'Четвер',
                                "П'ятниця",
                                'Субота',
                                'Неділя'
                              ]);
                            } else if (
                              newValue.includes('Понеділок') &&
                              newValue.includes('Вівторок') &&
                              newValue.includes('Середа') &&
                              newValue.includes('Четвер') &&
                              newValue.includes("П'ятниця") &&
                              newValue.includes('Субота') &&
                              newValue.includes('Неділя') &&
                              !values.deliveryDays.includes('Щодня')
                            ) {
                              setFieldValue('deliveryDays', [
                                'Щодня',
                                'Понеділок',
                                'Вівторок',
                                'Середа',
                                'Четвер',
                                "П'ятниця",
                                'Субота',
                                'Неділя'
                              ]);
                            } else if (
                              newValue.includes('Понеділок') &&
                              newValue.includes('Вівторок') &&
                              newValue.includes('Середа') &&
                              newValue.includes('Четвер') &&
                              newValue.includes("П'ятниця") &&
                              newValue.includes('Субота') &&
                              newValue.includes('Неділя') &&
                              !newValue.includes('Щодня') &&
                              values.deliveryDays.includes('Щодня')
                            ) {
                              setFieldValue('deliveryDays', []);
                            } else {
                              setFieldValue('deliveryDays', newValue);
                            }
                          }}
                          multiple
                          id="deliveryDays-autocomplete"
                          options={[
                            'Щодня',
                            'Понеділок',
                            'Вівторок',
                            'Середа',
                            'Четвер',
                            "П'ятниця",
                            'Субота',
                            'Неділя'
                          ]}
                          disableClearable
                          disableCloseOnSelect
                          getOptionLabel={(option) => {
                            switch (option) {
                              case 'Щодня':
                                return 'Щодня';
                              case 'Понеділок':
                                return 'Пн';
                              case 'Вівторок':
                                return 'Вт';
                              case 'Середа':
                                return 'Ср';
                              case 'Четвер':
                                return 'Чт';
                              case "П'ятниця":
                                return 'Пт';
                              case 'Субота':
                                return 'Сб';
                              case 'Неділя':
                                return 'Нд';
                              default:
                                return;
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                disableRipple
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option}
                            </li>
                          )}
                          // style={{ width: 270 }}
                          renderInput={(params) => {
                            let newParams = params;
                            // if (newParams) {
                            //   let newItems =
                            //     params?.InputProps?.startAdornment &&
                            //     params?.InputProps?.startAdornment?.props &&
                            //     params?.InputProps?.startAdornment?.props?.children &&
                            //     params?.InputProps?.startAdornment?.props?.children.length !== 0
                            //       ? params?.InputProps?.startAdornment?.props?.children.filter(
                            //           (el) => el !== 'Щодня'
                            //         )
                            //       : [];
                            //       if(params?.InputProps?.startAdornment){
                            //   newParams.InputProps.startAdornment.props.children = newItems;}
                            // }
                            return (
                              <CssTextField
                                {...newParams}
                                // label="Дні відправки*"
                                placeholder={
                                  values.deliveryDays.length === 0 ? 'Дні відправки*' : ''
                                }
                              />
                            );
                          }}
                          renderTags={(list) => {
                            if (list.includes('Щодня')) {
                              return <span>Щодня</span>;
                            } else {
                              let displayList = list
                                .map((option) => {
                                  switch (option) {
                                    case 'Понеділок':
                                      return 'Пн';
                                    case 'Вівторок':
                                      return 'Вт';
                                    case 'Середа':
                                      return 'Ср';
                                    case 'Четвер':
                                      return 'Чт';
                                    case "П'ятниця":
                                      return 'Пт';
                                    case 'Субота':
                                      return 'Сб';
                                    case 'Неділя':
                                      return 'Нд';
                                    default:
                                      return null;
                                  }
                                })
                                .join(', ');
                              return <span>{displayList}</span>;
                            }
                          }}
                        />

                        <div
                          style={{
                            color: 'red',
                            margin: '5px 0px',
                            fontSize: '14px',
                            fontFamily: 'FixelText-Regular'
                          }}
                        >
                          {touched.deliveryDays && errors.deliveryDays}
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        sx={{
                          display: 'flex',
                          alignItems: 'left',
                          flexDirection: 'column',
                          position: 'relative',
                          height: '190px'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ mb: 2, fontSize: 16, fontFamily: 'FixelText-SemiBold' }}
                        >
                          Орієнтовний термін збору замовлення:
                        </Typography>
                        <Typography
                          variant="subtitle"
                          sx={{ fontSize: 16, color: '#B1B1B1', mb: 2 }}
                        >
                          Вкажіть максимальну кількість днів для збору замовлення*.
                        </Typography>
                        <CssTextField
                          label=""
                          placeholder="Кіл-сть днів*"
                          variant="outlined"
                          fullWidth
                          size="normal"
                          sx={{ marginTop: '5px !important' }}
                          inputProps={{ style: { textAlign: 'left' } }}
                          error={Boolean(touched.estimatedTime && errors.estimatedTime)}
                          {...getFieldProps('estimatedTime')}
                          value={values.estimatedTime}
                        >
                          {values.estimatedTime}
                        </CssTextField>
                        {touched.estimatedTime && errors.estimatedTime && (
                          <div
                            style={{
                              color: 'red',
                              fontSize: '14px',
                              fontFamily: 'FixelText-Regular'
                            }}
                          >
                            {errors.estimatedTime}
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
                  >
                    {!isLoading ? (
                      <>
                        <LetsGoBtn3
                          disableRipple
                          disabled={
                            values.nameService.length < 2 ||
                            values.category.length === 0 ||
                            values.availability.length === 0 ||
                            values.price.length === 0 ||
                            errors?.price ||
                            errors?.valueOfInitOfMeasure ||
                            values.currency.length === 0 ||
                            values.valueOfInitOfMeasure.length === 0 ||
                            values.initOfMeasure.length === 0 ||
                            values.deliveryOption.length === 0 ||
                            values.paymentOption.length === 0 ||
                            values.deliveryDays.length === 0 ||
                            values.estimatedTime === 0 ||
                            errors?.estimatedTime ||
                            errors?.availableQuantity
                          }
                          size="large"
                          onClick={() => {
                            submitForm();
                          }}
                          width={257}
                          style={{ textTransform: 'inherit' }}
                          text={data ? 'Зберегти зміни' : 'Створити'}
                        />
                        {/*{data && (*/}
                        {/*  <LetsGoBtn2*/}
                        {/*    icon*/}
                        {/*    usedIcon={<DeleteOutlineIcon sx={{ color: '#60A5DF', mr: 1 }} />}*/}
                        {/*    onClick={() => {*/}
                        {/*      dispatch(*/}
                        {/*        setIsOpenDeleteModal({*/}
                        {/*          isOpen: true,*/}
                        {/*          text: 'цю послугу?',*/}
                        {/*          func: deleteService,*/}
                        {/*          id: data.id*/}
                        {/*        })*/}
                        {/*      );*/}
                        {/*    }}*/}
                        {/*    marginTop="0px"*/}
                        {/*    width={257}*/}
                        {/*    sx={{ textTransform: 'inherit', marginLeft: '20px !important' }}*/}
                        {/*    text="Видалити послугу"*/}
                        {/*  />*/}
                        {/*)}*/}
                      </>
                    ) : (
                      <div style={{ marginTop: '10px' }}>
                        <Spinner type="small" />
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          ) : null}
          {stage === '2' ? (
            <Grid container spacing={screenType !== 'desktop' ? 1 : 4}>
              <Grid item xs={12} md={12} lg={12}>
                <StyledLabel className="serviceModal-title-text">
                  {/* {translate('bonfair_service_modal')} */}
                  {'Доступно лише для преміум користувачів'}
                </StyledLabel>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
              >
                <Typography
                  sx={{ fontFamily: 'FixelText-Regular', textAlign: 'center', width: '430px' }}
                >
                  Щоб створити новий товар, вам необхідно перейти на Преміум тариф. Оформіть
                  підписку і отримайте доступ до всіх можливостей платформи.
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
              >
                <LetsGoBtn3
                  disableRipple
                  size="large"
                  onClick={() => {
                    navigate('/ua/tariffs');
                    setStage('1');
                    dispatch(setIsOpenServiceModal({ isOpen: false, data: null, setter: null }));
                  }}
                  width={257}
                  style={{ textTransform: 'inherit' }}
                  text={'Спробувати Преміум'}
                />
              </Grid>
            </Grid>
          ) : null}
          {stage === '3' ? (
            <Grid container spacing={screenType !== 'desktop' ? 1 : 4}>
              <Grid item xs={12} md={12} lg={12}>
                <StyledLabel className="serviceModal-title-text">
                  {/* {translate('bonfair_service_modal')} */}
                  {'Розширте тариф, щоб додати більше товарів'}
                </StyledLabel>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
              >
                <Typography
                  sx={{ fontFamily: 'FixelText-Regular', textAlign: 'center', width: '430px' }}
                >
                  Ви досягли ліміту на кількість створених товарів у вашому поточному тарифі. Щоб
                  створити більше товарів, перейдіть на розширений Преміум тариф у налаштуваннях.
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
              >
                <LetsGoBtn3
                  disableRipple
                  size="large"
                  onClick={() => {
                    navigate('/ua/account-settings');
                    setStage('1');
                    dispatch(setIsOpenServiceModal({ isOpen: false, data: null, setter: null }));
                  }}
                  width={257}
                  style={{ textTransform: 'inherit' }}
                  text={' Перейти до налаштувань'}
                />
              </Grid>
            </Grid>
          ) : null}
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    isOpenSearchBar: state.global.isOpenSearchBar,
    userData: state.global.userData
  };
};
export default connect(mapStateToProps)(ServiceModal);
